(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const d = document;
  const $$ = (s, r = d) => [...r.querySelectorAll(s)];
  d.documentElement.classList.add('hf-js');

  /* 1 + 7. scroll reveals with per-row stagger */
  const sel = '.hf-head,.hf-lane,.hf-card,.hf-promise>div,.hf-spot__grid>*,.hf-closer .hf-wrap>*,.hff-mark,.hff-grid>div';
  const targets = $$(sel);
  targets.forEach((el) => {
    el.classList.add('hf-rv');
    const sibs = [...el.parentElement.children].filter((c) => targets.includes(c));
    el.style.setProperty('--d', (sibs.indexOf(el) % 6) * 70 + 'ms');
  });
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('hf-in'); io.unobserve(e.target); }
  }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  targets.forEach((t) => io.observe(t));

  /* 5. count-ups */
  const count = (el, from, to, fmt, ms = 1000) => {
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(from + (to - from) * e);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const price = d.querySelector('.hf-spot__price');
  if (price) {
    const final = price.textContent.trim(), n = parseFloat(final.replace(/[^0-9.]/g, ''));
    const pio = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      pio.disconnect();
      count(price, 0, n, (v) => '$' + v.toFixed(2), 1200);
      setTimeout(() => (price.textContent = final), 1250);
    }), { threshold: 0.6 });
    pio.observe(price);
  }
  $$('.hf-hero__strip li').forEach((li) => {
    const m = li.textContent.match(/(\d+)-(\d+)/);
    if (!m) return;
    const full = li.textContent;
    const sio = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      sio.disconnect();
      count(li, 1, +m[2], (v) => full.replace(m[0], m[1] + '-' + Math.round(v)), 1400);
      setTimeout(() => (li.textContent = full), 1450);
    }), { threshold: 0.6 });
    setTimeout(() => sio.observe(li), 1600);
  });

  /* 3 + 4. magnetic buttons, card tilt, add-to-cart pulse */
  if (matchMedia('(hover: hover)').matches) {
    let btn = null, img = null;
    const reset = (el, ...props) => el && props.forEach((p) => el.style.removeProperty(p));
    d.addEventListener('pointermove', (e) => {
      const b = e.target.closest && e.target.closest('.hf-btn,button[name="add"]');
      if (btn && btn !== b) reset(btn, '--mx', '--my');
      btn = b;
      if (b) {
        const r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5) * 12 + 'px');
        b.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5) * 9 + 'px');
      }
      const c = e.target.closest && e.target.closest('.hf-card__img');
      if (img && img !== c) reset(img, '--rx', '--ry');
      img = c;
      if (c) {
        const r = c.getBoundingClientRect();
        c.style.setProperty('--ry', ((e.clientX - r.left) / r.width - 0.5) * 9 + 'deg');
        c.style.setProperty('--rx', (0.5 - (e.clientY - r.top) / r.height) * 9 + 'deg');
      }
    }, { passive: true });
  }
  d.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('button[name="add"],.add-to-cart-button');
    if (!b) return;
    b.classList.remove('hf-pulse'); void b.offsetWidth; b.classList.add('hf-pulse');
  });

  /* 6 + 8. scroll-reactive marquee and parallax, one shared rAF loop */
  const track = d.querySelector('.hf-ticker__track');
  const anim = track && track.getAnimations()[0];
  let hover = false, vel = 0, rate = 1, lastY = 0, lastT = performance.now(), sy = 0, dirty = true;
  if (track) {
    track.parentElement.addEventListener('pointerenter', () => (hover = true));
    track.parentElement.addEventListener('pointerleave', () => (hover = false));
  }
  const spot = $$('.hf-spot__img img'), floats = $$('.hf-float--a,.hf-float--b');
  addEventListener('scroll', (e) => {
    const t = e.target === d ? d.scrollingElement : e.target;
    sy = t.scrollTop || 0;
    const now = performance.now(), dt = Math.max(16, now - lastT);
    vel = Math.max(vel, (Math.abs(sy - lastY) / dt) * 1000);
    lastY = sy; lastT = now; dirty = true;
  }, { capture: true, passive: true });
  const loop = () => {
    if (anim) {
      const target = hover ? 0.2 : 1 + Math.min(vel / 500, 5);
      rate += (target - rate) * 0.08;
      anim.playbackRate = rate;
    }
    vel *= 0.92;
    if (dirty) {
      spot.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        el.style.setProperty('--py', ((r.top + r.height / 2 - innerHeight / 2) / innerHeight) * -46 + 'px');
      });
      floats.forEach((el, i) => el.style.setProperty('--py', sy * (i ? 0.05 : -0.06) + 'px'));
      dirty = false;
    }
    requestAnimationFrame(loop);
  };
  requestAnimationFrame(loop);
})();